<template>
  <div class="dynamic-fields">
    <el-row
      v-for="atType in attributeTypes"
      :key="atType.key"
      :class="{'range-slider': atType.type === 'range'}"
    >
      <span class="filter-title">
        {{ $t('filter.'+ atType.key + '.label') }}
      </span>
      <div
        v-if="atType.type === 'range'"
        class="block"
      >
        <range-primary
          tooltip-class="tooltip-primary"
          :show-tooltip="true"
          :money="atType.key === 'price'"
          range
          transition
          :value="getFieldValue(atType)"
          :force-tooltip-open="true"
          :min="atType.type_data_parsed.min | limitReplacers('number')"
          :max="atType.type_data_parsed.max | limitReplacers('number')"
          @change="setFieldValue($event, atType)"
        />
      </div>

      <select-primary-js
        v-if="atType.type === 'list'"
        :value="getFieldValue(atType)"
        item-key="value"
        item-name="name"
        item-value="value"
        :options="getOptions(atType) || []"
        @input="setFieldValue($event, atType)"
      >
        <!--        <template slot="singleLabel" slot-scope="props">-->
        <!--          {{ getFieldValue(atType).value.translations[locale] }}-->
        <!--        </template>-->
      </select-primary-js>
      <location v-if="atType.type === 'address'" />
      <sort-ads-dropdown
        v-if="atType.type === 'sort'"
        :has-price="!!attributeTypes.find(it => it.key === 'price')"
      />
    </el-row>
    <!--<el-row>-->
    <!--<span class="filter-title">Make</span>-->
    <!--<select-primary-js-->
    <!--placeholder=""-->
    <!--label="name"-->
    <!--v-model="filters_category"-->
    <!--:options="categories">-->
    <!--</select-primary-js>-->
    <!--</el-row>-->
  </div>
</template>

<script>
import isEqual from 'lodash-es/isEqual';
import get from 'lodash-es/get';
// import { mapState } from 'vuex';
import dynamicFields from '@/mixins/filters/dynamic-fields';
import Location from '@/components/MainLeftFilters/Location';
import RangePrimary from '../RangePrimary';
import SelectPrimaryJs from '../SelectPrimaryJs';
import SortAdsDropdown from '../../Ads/SortAdsDropdown';

export default {
  components: {
    RangePrimary,
    SelectPrimaryJs,
    Location,
    SortAdsDropdown,
  },
  mixins: [dynamicFields],
  computed: {
    attributeValues: {
      get() {
        return this.attributeTypes;
      },
    },
    // ...mapState({
    //   locale: state => state.locale,
    // }),
  },
  watch: {
    attributeTypes(newVal, oldVal) {
      // Slider tooltip not freeze fix ( when dynamic attribute fields change )
      if (newVal && oldVal && !isEqual(newVal.map(item => item.id), oldVal.map(item => item.id))) {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
        });
      }
    },
  },
  methods: {
    getOptions(type) {
      const options = get(type, 'type_data_parsed', []);
      if (!type.parent_key) {
        return options;
      }

      const parentType = this.attributeValues.find(item => item.key === type.parent_key);
      const parentValue = this.getFieldValue(parentType);

      if (parentType && parentValue) {
        return options.filter(item => item.parent === parentValue.value);
      }
      return options;
    },
    // onChange(type) {
    //   this.getOptions(type);
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/MainLeftFilters/LeftFilter/DynamicFields.vue